export default __webpack_public_path__ + "static/media/VolvoNovum-Bold.85bcbc3c.ttf";